import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { destroy } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import ConfirmationStep from '../ConfirmationStep';
import StepWizard from '../StepWizard';
import PercentDepositsForm from './components/PercentDepositsForm';
import PercentDepositsConfirmation from './components/PercentDepositsConfirmation';
import { percentDepositsApplicationDraft, percentDepositsApplication } from '../../services/API';
import config from 'config';

const formName = 'percentDepositsSituationsForm';
const formNameConfirmation = 'percentDepositsSituationsFormConfirmation';

export const PercentDepositsPage = ({ taxAuthority, periods, banks }) => {
  const dispatch = useDispatch();
  const [confirmData, setConfirmData] = useState();
  const searchParams = new URLSearchParams(window.location.search);
  const bankInnParam = searchParams.get('bankInn');
  const yearParam = searchParams.get('year');

  useEffect(() => {
    return () => {
      dispatch(destroy(formName));
      dispatch(destroy(formNameConfirmation));
    };
  }, []);

  const onSubmit = (nextStep) => async (values) => {
    const {
      yearf: { value: yearf },
      bank: { label: bankName, value: bankINN },
      reasonNameNum,
      ...rest
    } = values?.toJS();

    const getBank = () => {
      if (bankINN && yearf) {
        const reorganizedBank = banks[yearf].find((bank) => bank?.reorganized?.inn === bankINN);
        if (reorganizedBank) {
          return reorganizedBank;
        } else {
          return banks[yearf].find((bank) => bank.inn === bankINN && !bank.reorganized);
        }
      }
    };

    const data = {
      yearf: yearf.toString(),
      bankName,
      bankINN,
      bankKPP: getBank().kpp,
      serNum: getBank().serNum,
      numCorr: getBank().numCorr,
      taxpayerName: rest,
      taxInspectionCode: taxAuthority.code,
      taxInspectionTitle: taxAuthority.name,
      reasonNameNum,
      sumProc: getBank().incomeSum,
    };

    const result = await percentDepositsApplicationDraft(data);

    if (result.isOk) {
      setConfirmData(result.data);
      dispatch(push({ query: { step: nextStep } }, { persistQuery: true }));
    } else {
      throw result.data.error;
    }
  };

  const onSubmitConfirmation = (nextStep) => async () => {
    const { pdf, cardId } = confirmData;

    const result = await percentDepositsApplication({ pdf, cardId });

    if (result.isOk) {
      dispatch(push({ query: { step: nextStep } }, { persistQuery: true }));
    } else {
      throw result.data.error;
    }
  };

  const steps = useMemo(() => {
    return [
      {
        key: 'FILLING',
        title: 'Заполнение',
        formName,
        // eslint-disable-next-line react/display-name
        component: (props) => (
          <PercentDepositsForm
            {...props}
            // eslint-disable-next-line react/prop-types
            onSubmit={onSubmit(props.nextStep)}
            taxAuthority={taxAuthority}
            periods={periods}
            banks={banks}
            bankInn={bankInnParam}
            year={yearParam}
          />
        ),
      },

      {
        key: 'CONFIRMATION',
        title: 'Подтверждение',
        formName: formNameConfirmation,
        buttonText: 'Отправить',
        // eslint-disable-next-line react/display-name
        component: (props) => (
          <PercentDepositsConfirmation
            {...props}
            // eslint-disable-next-line react/prop-types
            onSubmit={onSubmitConfirmation(props.nextStep)}
            pdf={confirmData?.pdf}
          />
        ),
      },

      {
        key: 'SENDING',
        title: 'Отправка',
        // eslint-disable-next-line react/display-name
        component: (props) => (
          <div className="bg-white p-4 border mb-4">
            <ConfirmationStep showBiggest {...props} />
          </div>
        ),
        hideControls: true,
      },
    ];
  }, [onSubmit, confirmData]);

  return (
    <div className={'boo'}>
      <StepWizard steps={steps} disableStepsNavigation={true} onExit={config.goToNewAppeals} />
    </div>
  );
};

PercentDepositsPage.propTypes = {
  periods: PropTypes.array,
  banks: PropTypes.object,
  taxAuthority: PropTypes.object,
};
